
export const fieldsToSearch = [
    'idEvaluacion',
    'idPaciente',
    'paciente',
    'programa',
    'planCuidado',
    'profesional'
];